import { LogoutOutlined } from '@mui/icons-material';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { logout } from 'src/auth';

export default function LogoutMenuItem() {
  const handleLogout = () => {
    try {
      logout();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <ListItemButton sx={{ borderRadius: 0 }} onClick={handleLogout}>
      <ListItemIcon>
        <LogoutOutlined />
      </ListItemIcon>
      <ListItemText primary='Logout' />
    </ListItemButton>
  );
}
